<div *ngIf="canSwitchCompany" class="switcher-container mt-5">
  <div class="switcher-heading" i18n>
    ORGANIZATIONS
  </div>
  <div class="companies-list" [class.no-events]="isSwitchingCompany">
    <div *ngFor="let company of companiesList" class="list-item clickable d-flex justify-space-between align-items-center"
    (click)="(!company.selected) && switchCompany(company.id)"
    [class.active]="company.selected">
      <div class="company-details d-flex align-items-center">
        <div class="company-icon d-flex justify-center align-items-center border-radius-circle">
          <svg    width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 10h7v4h2V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12h2v-4zm4 4h2v-3H9v3zm-1 0v-3H6v3h2zm7 0h2v1H0v-1h2V2a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v12zM6 3v2H5V3h1zm4 2H9V3h1v2zM8 3v2H7V3h1zM6 6v2H5V6h1zm2 0v2H7V6h1zm2 0v2H9V6h1zm1 2V6h1v2h-1zm0-5h1v2h-1V3z" fill="#032281"/></svg>
        </div>
        <div class="company-info ml-12 d-flex flex-col">
          <div class="company-title">{{ company.name }}</div>
          <div class="company-stats d-flex align-items-center mt-2">
            <div>
              {{ company.driverCount }}
              <ng-container i18n>Drivers</ng-container>
            </div>
            <span class="dot ml-5 mr-5"></span>
            <div>
              {{ company.vehicleCount }}
              <ng-container i18n>Vehicles</ng-container>
            </div>
            <span class="dot ml-5 mr-5"></span>
            <div>
              {{ company.assetCount }}
              <ng-container i18n>Assets</ng-container>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="company.selected" class="current-view-tag" i18n>
        Current View
      </div>
    </div>
  </div>
  <div *ngIf="showMoreActive" class="divider"></div>
  <div *ngIf="showMoreActive" class="companies-show-more">
    <span class="clickable" (click)="toggleShowMore()">
      <ng-container i18n>Show </ng-container>
      <ng-container *ngIf="showMore else collpaseCompaniesTemp" i18n>less</ng-container> 

      <ng-template #collpaseCompaniesTemp>
        {{ listItemsLeft }}
        <ng-container i18n>more</ng-container> 
      </ng-template>
    </span>
  </div>
  <div class="divider"></div>
</div>